var React = require('react');

function WaveAbTesting (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M453.673 142.739C291.608 145.135 83.6974 130.428 0 122.776V0H1728V36.9326H1538.45C1482.3 36.9326 1217.73 62.8852 1107.68 82.8487C997.631 102.812 656.254 139.745 453.673 142.739Z","fill":"#064861"}));
}

WaveAbTesting.defaultProps = {"viewBox":"0 0 1728 143","fill":"none"};

module.exports = WaveAbTesting;

WaveAbTesting.default = WaveAbTesting;
